import { useMemo } from "react";
import PhoneInput from "react-phone-input-2";
import es from 'react-phone-input-2/lang/es.json';
import de from 'react-phone-input-2/lang/de.json';
import 'react-phone-input-2/lib/high-res.css'
import { getCountriesList } from "../configs/getCountriesList";

export const PhoneInputI18n = ({ language, phone, onSelect, isInvalid }) => {


    const sortedCountries = getCountriesList(language);

    const preparedCountries = useMemo(() => {
        return sortedCountries.map((country) => country.code.toLowerCase());
    }, [sortedCountries]);

    const localization = useMemo(() => {
        switch (language) {
            case "es-ES":
                return es;
            case "de":
                return de;
            default:
                return false;
        }
    }, [language]);

    return (
        <>
            {language && (
                <PhoneInput
                    inputProps={{
                        name: "phone",
                        type: "tel",
                        autoComplete: "tel-country-code",
                        maxLength: 25,
                    }}
                    dropdownStyle={{
                        position: "absolute", bottom: "100%", top: "auto", left: 0, right: 0,
                    }}
                    enableLongNumbers={true}
                    value={phone}
                    inputClass={`form-control ${isInvalid && "is-invalid"} w-100`}
                    country={language !== "en-US" ? language.split("-")[0] : "us"}
                    localization={localization}
                    enableSearch
                    placeholder={""}
                    preferredCountries={preparedCountries.slice(0, 12)}
                    onChange={(value) => {
                        if (!value.startsWith('+') && value.length > 0) {
                            value = `+${value}`;
                        }
                        onSelect(value);
                    }}
                />
            )}
        </>
    );
};
